import styled, { keyframes } from 'styled-components';

export const AddToCart = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  & .button {
    font-size: 14px;
    font-weight: 500;
    color: #ef4e5e;
    border: 1px solid #ef4e5e;
    height: 28px;
    line-height: 24px;
    text-align: center;
    border-radius: 5px;
    margin: auto 0 6px;
    z-index: 9;
    @media (min-width: 720px) {
      cursor: pointer;
    }
  }

  & .goToCartButton {
    font-size: 14px;
    font-weight: 500;
    background-color: #ef4e5e;
    color: #fff;
    height: 28px;
    line-height: 26px;
    text-align: center;
    border-radius: 5px;
    margin: 0 0 6px;
    border: 1px solid #ef4e5e;
    z-index: 9;
    @media (min-width: 720px) {
      cursor: pointer;
    }
  }
`;

const rotate = keyframes`
0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
const checkmark = keyframes`  0% {
    height: 0;
    width: 0;
    opacity: 1;
  }
  20% {
    height: 0;
    width: 7px;
    opacity: 1;
  }
  40% {
    height: 12px;
    width: 7px;
    opacity: 1;
  }
  100% {
    height: 12px;
    width: 7px;
    opacity: 1;
  }`;

// Here we create a component that will rotate everything we pass in over two seconds
export const CssLoader = styled.div`
  margin-bottom: 20px/2;
  border: 1px solid ${(props) => props.borderColor || 'rgba(0, 0, 0, 0.2)'};
  border-left-color: ${(props) => props.theme || '#ef4e5e'};
  animation: ${rotate} 1.2s infinite linear;
  position: relative;
  display: inline-block;
  vertical-align: ${(props) => (props.mdpage ? 'baseline' : 'top')};
  border-radius: 50%;
  width: ${(props) => (props.bogo ? '18px' : '20px')};
  height: ${(props) => (props.bogo ? '18px' : '20px')};
  top: ${(props) =>
    props.newUI
      ? '25%'
      : props.aplusplus
        ? '10px'
        : props.bogo
          ? '5px'
          : 'auto'};

  @media (max-width: 720px) {
    top: ${(props) =>
      props.aplusplus
        ? '10px'
        : props.bogo || props.isCategoryPage
          ? '5px'
          : 'auto'};
  }

  &.load-complete {
    -webkit-animation: none;
    animation: none;
    border-color: ${(props) => props.theme || '#ef4e5e'};
    transition: border 500ms ease-out;
  }

  & .checkmark {
    display: none;

    &.draw {
      &:after {
        animation-duration: 400ms;
        animation-timing-function: ease;
        animation-name: ${checkmark};
        transform: scaleX(-1) rotate(135deg);
      }
    }

    &:after {
      opacity: 1;
      height: 12px;
      width: 7px;
      transform-origin: left top;
      border-right: 3px solid
        ${(props) => props.borderColor || props.theme || '#ef4e5e'};
      border-top: 3px solid
        ${(props) => props.borderColor || props.theme || '#ef4e5e'};
      content: '';
      left: 2px;
      top: 9px;
      position: absolute;
    }
  }
`;
